<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="10a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
        <div ref="textB" data-scene="10b">
          <div v-for="line in copy.bottom" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure anim-scene-10-a" ref="figureA" data-scene="10a">
          <Img :src="require('@/assets/scene10/spread10_a.png')" filename="spread10_a" />
        </figure>

        <figure class="o-section__figure" ref="figureA2" data-scene="10a2">
          <Img :src="require('@/assets/scene10/spread10_a2.png')" filename="spread10_a2" />
        </figure>

        <figure class="o-section__figure" ref="figureA3" data-scene="10a3">
          <Img :src="require('@/assets/scene10/spread10_a3.png')" filename="spread10_a3" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="10b">
          <Img :src="require('@/assets/scene10/spread10_b.png')" filename="spread10_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene10',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene10', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureA, this.$refs.figureA2, this.$refs.figureA3],
        translateY: ['20px', '0'],
        scale: [1.1, 1],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2, this.$refs.figureA3],
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: [this.$refs.figureA, this.$refs.figureA2, this.$refs.figureA3],
          filter: ['blur(25px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }

      this.$anime({
        targets: this.$refs.figureA2.querySelector('div'),
        translateY: ['0', '10px'],
        duration: this.options.durationRegular,
        easing: this.options.easing,
        loop: true,
        direction: 'alternate'
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateY: ['-60px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })
    }
  },

  components: {
    Img
  }
}
</script>
